
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/integrations/routing",
      function () {
        return require("private-next-pages/material-ui/integrations/routing.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/integrations/routing"])
      });
    }
  